// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"museum-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21V5L6 3L9 5V12L21 10V21H17V17H13V21H9H3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 21V5L6 3L9 5V12L21 10V21H17V17H13V21H9H3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-museum-2')
export default class Museum2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'museum-2',
    }
  }
}
